import React, { useState } from "react";
import "./FAQManagement.css";

const FAQManagement = ({ faqData, setFaqData }) => {
  const [newCategory, setNewCategory] = useState("User account");
  const [newQuestion, setNewQuestion] = useState("");
  const [newAnswer, setNewAnswer] = useState("");
  const [editingFAQ, setEditingFAQ] = useState(null);

  const categories = [
    "User account",
    "Community",
    "Identification",
    "Language",
    "Issue",
  ];

  const handleAddFAQ = () => {
    const updatedFaqData = [...faqData];
    const categoryIndex = updatedFaqData.findIndex(
      (cat) => cat.category === newCategory
    );

    if (categoryIndex >= 0) {
      updatedFaqData[categoryIndex].questions.push({
        question: newQuestion,
        answer: newAnswer,
      });
    } else {
      updatedFaqData.push({
        category: newCategory,
        questions: [
          {
            question: newQuestion,
            answer: newAnswer,
          },
        ],
      });
    }

    setFaqData(updatedFaqData);
    setNewCategory("User account");
    setNewQuestion("");
    setNewAnswer("");
  };

  const handleDeleteFAQ = (categoryIndex, questionIndex) => {
    const updatedFaqData = [...faqData];
    updatedFaqData[categoryIndex].questions.splice(questionIndex, 1);
    if (updatedFaqData[categoryIndex].questions.length === 0) {
      updatedFaqData.splice(categoryIndex, 1);
    }
    setFaqData(updatedFaqData);
  };

  const handleEditFAQ = (
    categoryIndex,
    questionIndex,
    updatedQuestion,
    updatedAnswer
  ) => {
    const updatedFaqData = [...faqData];
    updatedFaqData[categoryIndex].questions[questionIndex] = {
      question: updatedQuestion,
      answer: updatedAnswer,
    };
    setFaqData(updatedFaqData);
    setEditingFAQ(null);
  };

  const startEditing = (categoryIndex, questionIndex) => {
    setEditingFAQ({ categoryIndex, questionIndex });
  };

  const cancelEditing = () => {
    setEditingFAQ(null);
  };

  return (
    <div className="FAQM">
      <h2>Manage FAQ</h2>
      <div className="FAQM-form">
        <select
          value={newCategory}
          onChange={(e) => setNewCategory(e.target.value)}
        >
          {categories.map((category, index) => (
            <option key={index} value={category}>
              {category}
            </option>
          ))}
        </select>
        <input
          type="text"
          placeholder="Question"
          value={newQuestion}
          onChange={(e) => setNewQuestion(e.target.value)}
        />
        <textarea
          placeholder="Answer"
          value={newAnswer}
          onChange={(e) => setNewAnswer(e.target.value)}
        />
        <button onClick={handleAddFAQ}>Add FAQ</button>
      </div>
      <div className="FAQM-list">
        {faqData.map((category, catIdx) => (
          <div key={catIdx}>
            <h3>{category.category}</h3>
            {category.questions.map((q, qIdx) => (
              <div className="FAQMitem" key={qIdx}>
                {editingFAQ &&
                editingFAQ.categoryIndex === catIdx &&
                editingFAQ.questionIndex === qIdx ? (
                  <>
                    <input
                      type="text"
                      value={q.question}
                      onChange={(e) =>
                        handleEditFAQ(catIdx, qIdx, e.target.value, q.answer)
                      }
                    />
                    <textarea
                      value={q.answer}
                      onChange={(e) =>
                        handleEditFAQ(catIdx, qIdx, q.question, e.target.value)
                      }
                    />
                    <button
                      onClick={() =>
                        handleEditFAQ(catIdx, qIdx, q.question, q.answer)
                      }
                    >
                      Save
                    </button>
                    <button onClick={cancelEditing}>Cancel</button>
                  </>
                ) : (
                  <>
                    <p>
                      <strong>Q:</strong> {q.question}
                    </p>
                    <p>
                      <strong>A:</strong> {q.answer}
                    </p>
                    <div className="faqbtncontainer">
                      <button onClick={() => startEditing(catIdx, qIdx)}>
                        Edit
                      </button>
                      <button onClick={() => handleDeleteFAQ(catIdx, qIdx)}>
                        Delete
                      </button>
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQManagement;
